import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const AdRoll = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all <b>destination URLs</b> for new
      and existing ads.
    </p>
    <ConstructDestinationUrl platform={NorthbeamUtmPlatform.AD_ROLL} />
    <p className="mb-0">
      Follow the instructions{" "}
      <GenericExternalLink href="https://help.adroll.com/hc/en-us/articles/115002424872-Add-UTMs-to-your-AdRoll-Campaigns">
        here
      </GenericExternalLink>{" "}
      to edit or create a new ad with Northbeam&apos;s URL parameters.
    </p>
  </div>
);
